export interface TimeGatedTask {
  status: "pending" | "completed";
  visibleFrom?: string | null;
}

function minutesOfDay(hhmm: string): number {
  const [h, m] = hhmm.split(":").map(Number);
  return h * 60 + m;
}

export function isHiddenAt(task: TimeGatedTask, now: Date): boolean {
  if (task.status !== "pending" || !task.visibleFrom) return false;
  return now.getHours() * 60 + now.getMinutes() < minutesOfDay(task.visibleFrom);
}

export function partitionByVisibility<T extends TimeGatedTask>(tasks: T[], now: Date): { shown: T[]; hidden: T[] } {
  const shown: T[] = [];
  const hidden: T[] = [];
  for (const task of tasks) (isHiddenAt(task, now) ? hidden : shown).push(task);
  return { shown, hidden };
}

const SEPARATED_TIME = /^(\d{1,2})(?:[:.](\d{1,2}))?$/;
const COMPACT_TIME = /^(\d{1,2})(\d{2})$/;

export function parseTimeOfDay(input: string): string | null {
  const text = input.trim();
  const match = text.match(SEPARATED_TIME) ?? text.match(COMPACT_TIME);
  if (!match) return null;
  const hours = Number(match[1]);
  const minutes = Number(match[2] ?? 0);
  if (hours > 23 || minutes > 59) return null;
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
}
